export const MAPPING_STATUS_ITEMS = [
    { value: 'DRAFT', label: 'DRAFT', name: 'DRAFT' },
    { value: 'COMPLETED', label: 'COMPLETED', name: 'COMPLETED' },
];